/*
    Change long texts to something shorter.
    i.e. 'Aaaaaaaa' -> 'Aaaa...'
    {{ someStringHere | truncate: 0 : 82 : '...' : false }}
*/
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
    transform(value: string, startAt: number = 0, limit: number = 82, ellipsis: string = '...', completeWords: boolean = false): any {
        if (typeof value !== 'string' || typeof limit !== 'number') return value;

        if (!Number.isInteger(startAt) || startAt < 0) {
            startAt = 0;
        }

        if (value.length <= limit) return value;

        if (completeWords === true) {
            limit = value.substr(startAt, limit).lastIndexOf(' ');
        }

        let newValue: string = value.substr(startAt, limit);
        const notAllowedLastChars: string[] = [',', ' ', '.'];
        while (notAllowedLastChars.includes(newValue[newValue.length - 1])) {
            newValue = newValue.substr(0, newValue.length - 1);
        }

        return `${newValue}${value.length > limit && ellipsis ? ellipsis : ''}`;

    }
}
